module.exports = __webpack_public_path__ + "static/media/geckologo.5dd73306.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/ui/Logo/geckologo.svg
// module id = 401
// module chunks = 0